import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { BookedTrip } from '@ibe/models';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../../../../store';
import { takeWhile, map } from 'rxjs/operators';
import * as PromoVouchersActions from '../../../../store/actions/promo-vouchers.actions';
import { INDRADiscount } from '@ibe.models/promocode-vouchers.model.lib';
import { INDRADiscountService } from '@ibe.services/discount.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';

import {
	DISCOUNT_AMOUNT_TYPE_FIXED,
	DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
	DISCOUNT_APPLY_TO_TOTAL,
	DISCOUNT_APPLY_TO_FARE,
	DISCOUNT_TYPE_PROMOCODE,
	DISCOUNT_TYPE_VOUCHER,
	DISCOUNT_STATUS_ACTIVE,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP
} from '@ibe.config';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';


@Component({
	selector: 'app-voucher-or-promocode',
	templateUrl: './voucher-or-promocode.indra.component.html',
	styleUrls: ['./voucher-or-promocode.component.scss']
})
export class INDRAVoucherOrPromocodeComponent implements OnInit, OnDestroy {
	isAlive = true;

	INDRA_hasErrors: any = false;
	INDRA_hasPinErrors: any = false;
	environment = environment;

	formAdd: FormGroup = new FormGroup({
		promocode: new FormControl(null, Validators.required),
		promocodeemail: new FormControl(null, Validators.required),
		promocodepin: new FormControl(null, Validators.required)
	});

	validatingVoucherPromocode = false;
	showFormAdd = true;

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip;

	promocodesAndVoucher$: Observable<any> = this.store.select(fromStore.getSelectedPromoVouchers);
	promocodesAndVoucher: Array<any> = [];
	completePromocodeAndVoucherList: Array<any> = [];


	milesInFlightDiscount$: Observable<any> = this.store.select(fromStore.getMilesInFlightDiscount);
	milesInFlightDiscount: any;

    triggerHppRedFlag$: Observable<boolean> = this.indraPaymentService.triggerHppRedFlag$;
	triggerHppRedFlag: boolean = false;

	discounts: INDRADiscount[] = [];
	discountList: INDRADiscount[] = [];

	showError: boolean = false;
	loading: boolean = false;

	removeVoucherSubscription: Subscription;
	removePromocodeSubscription: Subscription;
	voucherCodeSubscription: Subscription;
	allSubscriptions: Subscription[] = [];

	errorsVouchers: Array<{ title: string, message: string }> = [];

	FIXED_DISCOUNT = DISCOUNT_AMOUNT_TYPE_FIXED;
	PERCENTAGE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_PERCENTAGE;

	flightPrice = 0;
	flightTax = 0;

	hasMilesDiscount: boolean = false;
	isBookingNotCreated: boolean = true;

	public inputCode: string = '';
	public inputEmail: string = '';
	public isVoucher: boolean = false;
	public showVoucherPin: boolean = false;


	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		private store: Store<fromStore.State>,
		protected router: Router,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private discountService: INDRADiscountService,
		private currencyService: INDRACurrencyService,
		private dateService: INDRADateService,
		private flightPriceService: INDRAFlightPriceService,
		private milesService: INDRAMilesService,
		private indraPaymentService: INDRAPaymentService,
		private paymentInfoService: PaymentService
	) {

		// query param value from the URL to identify whether the booking has been created or not
		const bookingCreatedParamValue = this.route.snapshot.paramMap.get('isBookingCreated');
		if (bookingCreatedParamValue === 'false') {
			this.isBookingNotCreated = true;
		} else {
			this.isBookingNotCreated = false;
		}

		this.bookAwardFlights$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.bookAwardFlights = value;
		});

		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.booked_trip = value;
				if (this.booked_trip && this.booked_trip.flights && this.booked_trip.flights.length > 0) {
					this.flightPrice = this.flightPriceService.computeSelectedFlightsTotalPrice(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
					this.flightTax = this.flightPriceService.computeSelectedFlightsTotalTax(this.booked_trip.flights, this.booked_trip.booking_type, this.bookAwardFlights);
				} else {
					this.flightPrice = 0;
					this.flightTax = 0;
				}
			});

		this.promocodesAndVoucher$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.promocodesAndVoucher = !value ? [] : value;
				this.promocodesAndVoucher = value;
				if (this.promocodesAndVoucher) {
					this.completePromocodeAndVoucherList = value;
					this.discounts = this.promocodesAndVoucher.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE);
					if (this.discounts.filter(discount => discount.type === DISCOUNT_TYPE_PROMOCODE).length === 1 ||
						this.discounts.filter(discount => discount.type === DISCOUNT_TYPE_VOUCHER).length === 3 ||
						this.discounts.length === 3) {
						this.showFormAdd = false;
					} else {
						this.showFormAdd = true;
					}
				} else {
					this.showFormAdd = true;
				}
			});

		this.milesInFlightDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(milesInFlightDiscount => {
				if (milesInFlightDiscount && milesInFlightDiscount.miles > 0) {
					this.hasMilesDiscount = true;
					this.showFormAdd = false;
				} else {
					this.hasMilesDiscount = false;
					this.showFormAdd = true;
				}
			});

		this.triggerHppRedFlag$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.triggerHppRedFlag = value;
			});

	}
	ngOnInit() {

	}

	ngOnDestroy() {
		this.isAlive = false;
		for (let sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

	INDRA_addVoucher() {
		if (this.triggerHppRedFlag) {
			return;
		}

		const isPromoEmail = this.formAdd.get('promocode').value && this.formAdd.get('promocodeemail').value;
		const hasPin = this.formAdd.get('promocodepin').value;
		if (this.formAdd.valid || isPromoEmail) {
			if (hasPin) {
				this.validatingVoucherPromocode = true;
				this.INDRA_hasPinErrors = false;
				this.INDRA_validateVoucherPin();
			} else {
				if (this.showVoucherPin) {
					this.INDRA_hasPinErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
				} else {
					const value = this.formAdd.get('promocode').value.trim();
					if (this.formAdd.get('promocodeemail')) {
						this.inputEmail = this.formAdd.get('promocodeemail').value.trim();
					}
					this.INDRA_hasErrors = false;
					this.validatingVoucherPromocode = true;
					this.INDRA_validateDiscounts(value);
				}
			}
		} else {
			if (this.inputCode && !this.isVoucher) {
				const value = this.formAdd.get('promocode').value.trim();

				this.INDRA_hasErrors = false;
				this.validatingVoucherPromocode = true;
				this.INDRA_validateDiscounts(value);
			} else {
				this.validatingVoucherPromocode = false;
				this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.voucherPromocodeRequired');
			}
		}
	}

	INDRA_validateDiscounts(value) {
		if (this.discounts.length > 1) {
			const voucherFilter = this.discounts.filter(cur => cur.type === DISCOUNT_TYPE_VOUCHER);
			const promoCodeFilter = this.discounts.filter(cur => cur.type === DISCOUNT_TYPE_PROMOCODE);

			if ((voucherFilter.length === 3 && promoCodeFilter.length === 0) || (voucherFilter.length === 2 && promoCodeFilter.length === 1)) {
				this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.maxDiscount');
				this.validatingVoucherPromocode = false;
				this.INDRA_formReset();
				return;
			}
		}
		const discountsIdx = this.discounts.findIndex(cur => cur.code == value);

		if (discountsIdx === -1) {
			this.INDRA_validatePromoCode(value);
		} else {
			this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.promoVoucherExists');
			this.validatingVoucherPromocode = false;
		}

	}

	INDRA_addAnotherVoucher() {
		if (this.triggerHppRedFlag) {
			return;
		}

		this.showFormAdd = true;
	}

	INDRA_removePromocode(discount) {
		if (this.triggerHppRedFlag) {
			return;
		}

		this.loading = true;
		this.removeVoucherSubscription = this.discountService.INDRA_removeVoucherInSession(discount.code).subscribe(voucher => {
			if (voucher.status === '200') {
				const currDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== discount.code);
				this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(currDiscountList));
				this.loading = false;
				this.INDRA_triggerBookingTotalsUpdate();
			} else {
				this.removePromocodeSubscription = this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(promo => {
					if (promo.status === '200' || promo.status === '406' || promo.errors === null) {
						const currDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== discount.code);
						this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(currDiscountList));
						this.loading = false;
						this.INDRA_triggerBookingTotalsUpdate();
					} else {
						this.showError = true;
						this.loading = false;
					}
				}, err => {
					if (err) {
						this.INDRA_triggerBookingTotalsUpdate();
						this.showError = true;
						this.loading = false;
					}
				});
			}
		}, error => {
			if (error) {
				this.INDRA_triggerBookingTotalsUpdate();
				this.showError = true;
			}
		});

		this.showFormAdd = true;
		this.allSubscriptions.push(this.removeVoucherSubscription);
		this.allSubscriptions.push(this.removePromocodeSubscription);

	}

	INDRA_close(event) {
		if (event) {
			this.showError = false;
		}

	}

	INDRA_validateVoucher(value) {
		this.validatingVoucherPromocode = true;
		const voucherRequest = {
			'voucher': value,
			'email': this.inputEmail
		};
		this.discountService.validateVoucherPromoCode(voucherRequest, DISCOUNT_TYPE_VOUCHER).subscribe((voucher: any) => {
			if (voucher.status === '200') {
				if (voucher.data === null) {
					// MFA is active for vouchers
					this.showVoucherPin = true;
					this.INDRA_hasPinErrors = false;
					this.validatingVoucherPromocode = false;
				} else {
					this.INDRA_applyVoucherDiscount(value, voucher);
				}
			} else {
				if (voucher.errors && voucher.errors.desc) {
				this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.invalidVoucherNumber');
				} else {
				this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
				}
				this.validatingVoucherPromocode = false;
			}
		},
		err => {
			this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate');
			this.validatingVoucherPromocode = false;
		});
	}

	INDRA_validatePromoCode(value) {
		this.discountService.validateVoucherPromoCode(value, DISCOUNT_TYPE_PROMOCODE, this.bookAwardFlights).subscribe((promo: any) => {

			if (promo.status === '200') {
				const currency = this.currencyService.INDRA_getCurrencySymbol();

				if (!promo.data.basicInfo || !promo.data.basicInfo.currency) {
					this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.invalidPromocode');
					this.validatingVoucherPromocode = false;

				} else if (promo.data.basicInfo.currency !== 'FFP' && promo.data.basicInfo.currency !== currency.name) {
					this.INDRA_hasErrors = this.INDRA_getTextTranslation('bookingSearch.errorMessage.promocodeInvalidCurrency');
					this.validatingVoucherPromocode = false;
					this.discountService.INDRA_removePromoCodeInSession(value); // added because backend api is not validating promocode currency

				} else if (promo.data.basicInfo.currency !== 'FFP' && this.bookAwardFlights) {
					this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.invalidPromocode');
					this.validatingVoucherPromocode = false;

				} else if (promo.data.basicInfo.currency === 'FFP' && !this.bookAwardFlights) {
					this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.milesPromocode');
					this.validatingVoucherPromocode = false;

				} else {
					const promoCodesIndex = this.discounts.findIndex(cur => cur.type.toLowerCase().trim() == DISCOUNT_TYPE_PROMOCODE);
					if (promoCodesIndex === -1) {
						const newDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== value);

						// this will only have a value after the flight has been selected, otherwise this property is not existing
						const actualDiscountAmount = promo.data && promo.data.fareData && promo.data.fareData.totalPromocodeDiscount ?
							promo.data.fareData.totalPromocodeDiscount : null;

						newDiscountList.push({
							code: value,
							type: DISCOUNT_TYPE_PROMOCODE,
							amount: promo.data.basicInfo.discounts[0].amountType === 2 && actualDiscountAmount ? actualDiscountAmount : promo.data.basicInfo.discounts[0].discount,
							currencyCode: promo.data.basicInfo.currency !== 'FFP' ? promo.data.basicInfo.currency : 'M',
							status: DISCOUNT_STATUS_ACTIVE,
							amountType: promo.data.basicInfo.discounts[0].amountType === 2 ? DISCOUNT_AMOUNT_TYPE_FIXED : DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
							applyTo: promo.data.extraInfo && promo.data.extraInfo.discounts ? promo.data.extraInfo.discounts[0].applyTo : null,
							actualValue: actualDiscountAmount ? actualDiscountAmount : (promo.data.basicInfo.discounts[0].amountType === 2 ? promo.data.basicInfo.discounts[0].discount : 0)
						});
						this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(newDiscountList));

						this.showFormAdd = false;
						this.INDRA_formReset();
						this.INDRA_triggerBookingTotalsUpdate();
					} else {
						this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.max1Promocode');
					}
					this.validatingVoucherPromocode = false;
				}
			} else {
				const fieldErrors = promo.errors && promo.errors.fieldErrors && promo.errors.fieldErrors.length > 0 ? promo.errors.fieldErrors : [];
				if (promo.status === '400' && fieldErrors.filter(error => error.code === '1083').length > 0) {
					this.INDRA_hasErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.milesPromocode');
					this.validatingVoucherPromocode = false;
				} else {
					this.INDRA_validateVoucher(value);
					// this.validatingVoucherPromocode = false;
				}
			}
		},
			error => {
				this.INDRA_validateVoucher(value);
			});
	}


	INDRA_validateVoucherPin() {
		const value = this.formAdd.get('promocode').value.trim();
		const email = this.formAdd.get('promocodeemail').value.trim();
		const mfaCode = this.formAdd.get('promocodepin').value.trim();

		this.voucherCodeSubscription =
			this.discountService.INDRA_validateVoucherPin(value, email, mfaCode).subscribe((voucher: any) => {
				if (voucher.status === '200') {
					this.INDRA_applyVoucherDiscount(value, voucher);
				} else {
					if (voucher.status === '403' && voucher.errors.desc) {
						this.INDRA_hasPinErrors = voucher.errors.desc;
					} else {
						this.INDRA_hasPinErrors = this.INDRA_getTextTranslation('voucherPromocodeSidebar.errorMessage.couldNotValidate')
					}
					this.validatingVoucherPromocode = false;
				}
			},
			err => {
				if (err) {
					if (err.status) {
						this.INDRA_hasPinErrors = this.INDRA_getTextTranslation('bookingSearch.errorMessage.couldNotValidate');
						this.validatingVoucherPromocode = false;
					}
				}
			}
		)
		this.allSubscriptions.push(this.voucherCodeSubscription);
	}

	INDRA_applyVoucherDiscount(value, voucher) {
		const voucherFilter = this.discounts.filter(cur => cur.type === DISCOUNT_TYPE_VOUCHER);
		if (voucherFilter.length <= 2) {
		const newDiscountList = this.completePromocodeAndVoucherList.filter(x => x.code !== value);
		newDiscountList.push({
			code: value,
			type: DISCOUNT_TYPE_VOUCHER,
			amount: voucher.data.voucher.balance,
			currencyCode: voucher.data.voucher.currency,
			status: DISCOUNT_STATUS_ACTIVE,
			amountType: DISCOUNT_AMOUNT_TYPE_FIXED,
			applyTo: DISCOUNT_APPLY_TO_TOTAL,
			actualValue: voucher.data.voucher.balance,
			email: this.inputEmail
		});
		this.store.dispatch(new PromoVouchersActions.PutPromoVouchersAction(newDiscountList));
		this.showFormAdd = false;
		this.INDRA_formReset();
		this.INDRA_triggerBookingTotalsUpdate();
		} else {
			this.INDRA_hasErrors = this.INDRA_getTextTranslation('bookingSearch.errorMessage.voucherLimit');
		}
		this.validatingVoucherPromocode = false;
	}


	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_redirectToUrl(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	// only for percentage-type promocodes
	INDRA_displayActualDiscountAmount(discount) {
		if (discount.currencyCode != 'M') {
			return discount.actualValue;
		} else {
			return discount.actualValue.toFixed(0);
		}
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() {
		this.closeSidebar();
	}

	async INDRA_removeMiles() {
		if (this.router.url.includes('/booking/flights') || this.router.url.includes('/booking/flights-multicity')) {
			this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
		} else {
			const updateMilesPromise = await this.milesService.INDRA_updateMiles(0).toPromise();
			this.milesService.oldMilesValue = 0;
			this.INDRA_triggerBookingTotalsUpdate();
		}

		this.hasMilesDiscount = false;

		// remove discounts on store and update miles slider 
		this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ miles: 0, cash: 0 }));
		this.store.dispatch(new MilesBarActions.SetDiscount(0));
		this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction([]));
	}

	INDRA_triggerBookingTotalsUpdate() {
		if (this.router.url.includes('review-your-trip') || this.router.url.includes('extras-to-your-trip') || (this.isBookingNotCreated && this.router.url.includes('payment'))) {
			this.paymentInfoService.setUpdateBookingTotals(true);
		}
	}

	public INDRA_formReset() {
		this.formAdd.reset();
		this.inputCode = null;
		this.isVoucher = false;
	}


	public INDRA_valuechange(event) {
        this.inputCode = event;
    	if((this.inputCode.toUpperCase()).includes('VCHDB')){
    	    this.isVoucher = false;
			this.showVoucherPin = false;
    		this.formAdd.controls['promocodeemail'].setValue(null);
			this.formAdd.controls['promocodepin'].setValue(null);
    	}else{
    	    if (this.inputCode.length >= 19 && this.inputCode.length <= 20) {
                this.isVoucher = true;
            } else {
                this.isVoucher = false;
				this.showVoucherPin = false;
                this.formAdd.controls['promocodeemail'].setValue(null);
				this.formAdd.controls['promocodepin'].setValue(null);
            }
        }
    }
}
